import React, { Component } from "react";

import { Route } from "react-router";
import routes from "../../boot/routeConfig";
import Header from "../../components/Header/Header";
import { ConnectedRouter } from "react-router-redux";
import CSSModules from "react-css-modules";
import styles from "./styles.scss";
import toast, { ToastDOM } from "../../components/Toast/Toast";
import Menu from "../../components/Menu/Menu";
import "./unhide.css";
import Authorize from "../../components/Auth/Auth";

const renderRoutes = () => {
   const rtn = routes.map((s, index) => (
      <Route style={{ flex: 1, display: "flex", flexDirection: "column" }} {...s} key={index + "_" + window.location.href} />
   ));
   return rtn;
};

@CSSModules(styles, { allowMultiple: true })
export default class extends Component {
   render() {
      return (
         <ConnectedRouter history={this.props.history}>
            <div styleName="wraps">
               {/* header */}
               <Header height={this.props.height} width={this.props.width} />
               {/* content */}
               <div styleName="content-wrap">
                  <Menu />
                  <div id="content" styleName="content-class" id="content-scroll">
                     <Authorize isRoute={true}>{renderRoutes()}</Authorize>
                  </div>
               </div>
               <div>{/* footer */}</div>

               <div id="shell-portal" styleName="portal" />
               <div>
                  <ToastDOM />
               </div>
            </div>
         </ConnectedRouter>
      );
   }
}



// WEBPACK FOOTER //
// ./src/ui/Shell/shell.js